// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__f7D3k","sidebar__wrapper":"Sidebar_sidebar__wrapper__n0Gdr","sidebar__support":"Sidebar_sidebar__support__i5R5G"};